import React from 'react';
import { PageContainer } from 'components';
import { CommonProvider } from 'providers';
import Content from './content';
import ContentOld from '../customerListOld'
import { constBreadCrumbsTitle, getDynamicReportPages, getDynamicObjectAction } from 'utility';

const customerListReport = () => {
  const reportElement = getDynamicReportPages(['menuCustomerList'])
  const actionsList =
    getDynamicObjectAction([
      'followersListFinancialPage',
    ])

  const hint = 'لیست مشتریان خود را می‌توانید در زیر مشاهده نمایید.';
  return (
    <>
      <PageContainer
        description={hint}
        title="لیست مشتریان"
        pageKey={reportElement['menuCustomerList'] ? null : "customers"}
        breadcrumbs={constBreadCrumbsTitle.CUSTOMER_LIST}
      >
        {actionsList['followersListFinancialPage'] && (
          <CommonProvider>
            {
              reportElement['menuCustomerList'] ? (<Content />) : (<ContentOld />)
            }
          </CommonProvider>
        )}
      </PageContainer>
    </>
  );
};

export default customerListReport;

